import {
  Row,
  Col,
  Card,
  Table,
  Button,
  Avatar,
  Typography,
  message,
  Select,
  Input,
} from "antd";
import { CopyOutlined, PlusOutlined, SearchOutlined } from "@ant-design/icons";
import { Link, NavLink, useHistory, useLocation } from "react-router-dom";
import axios from "axios";
import { useEffect, useState } from "react";
import Spinner from "../components/common/Spinner/Spinner";
import jwtDecode from "jwt-decode";

const { Title } = Typography;

const columns = [
  {
    title: "LOCATION",
    dataIndex: "location",
    key: "location",
    // width: "25%",
  },
  {
    title: "ADDRESS",
    key: "address",
    dataIndex: "address",
  },
  {
    title: "CLIENT",
    key: "client",
    dataIndex: "client",
  },
  {
    title: "REGION",
    key: "region",
    dataIndex: "region",
  },
  {
    title: "COST CENTER",
    key: "costCenter",
    dataIndex: "costCenter",
  },
  {
    title: "EMAILS",
    key: "email",
    dataIndex: "email",
  },
  // {
  //   title: "EMAIL 2",
  //   key: "email2",
  //   dataIndex: "email2",
  // },
];

const clienti = [
  {
    label: "All Clients",
    value: "All Clients",
  },
  {
    label: "Mega Image",
    value: "Mega Image",
  },
  {
    label: "LSDV",
    value: "LSDV",
  },
  {
    label: "Sly Nutritia",
    value: "Sly Nutritia",
  },
  {
    label: "RER Ecologic",
    value: "RER Ecologic",
  },
  {
    label: "Grupul Tei",
    value: "Grupul Tei",
  },
  {
    label: "Orshar Logistics",
    value: "Orshar Logistics",
  },
  {
    label: "Aquila",
    value: "Aquila",
  },
  {
    label: "Quehenberger Logistics",
    value: "Quehenberger Logistics",
  },
  {
    label: "NEPI",
    value: "NEPI",
  },
  {
    label: "Professional Farmaline",
    value: "Professional Farmaline",
  },
  {
    label: "Pepco",
    value: "Pepco",
  },
  {
    label: "Electromagnetica",
    value: "Electromagnetica",
  },
  {
    label: "Other",
    value: "Other",
  },
];

const { Search } = Input;

function Locations() {
  const history = useHistory();
  const location = useLocation();

  const [token, setToken] = useState(localStorage.getItem("token"));
  const [messageApi, contextHolder] = message.useMessage();

  const [loading, setLoading] = useState(false);
  const [locations, setLocations] = useState();

  const [selectedClient, setSelectedClient] = useState("All Clients");

  const [query, setQuery] = useState("");
  const [loadingClients, setLoadingClients] = useState(false);
  const [clients, setClients] = useState([]);

  const success = () => {
    messageApi.open({
      type: "success",
      content: "Location ID copied to clipboard",
    });
  };

  const copyToClipBoard = async (copyMe) => {
    try {
      await navigator.clipboard.writeText(copyMe);
      success();
    } catch (err) {
      // setCopySuccess('Failed to copy!');
    }
  };

  const data = locations
    ?.filter((location) =>
      query === ""
        ? location
        : location.locationName.toLowerCase().includes(query.toLowerCase())
    )
    .filter((location) =>
      selectedClient === "All Clients"
        ? location
        : location.client === selectedClient
    )
    .map((location) => {
      return {
        key: location.id,
        location: (
          <>
            <Avatar.Group>
              <div
                className="avatar-info"
                style={{ cursor: "pointer" }}
                onClick={() => copyToClipBoard(location?.id)}
              >
                <Title level={5}>
                  {location?.locationName}{" "}
                  <CopyOutlined style={{ color: "#1ec8ff" }} />
                </Title>
                <p>{location?.locationCoordinates} </p>
              </div>
            </Avatar.Group>{" "}
          </>
        ),

        address: (
          <>
            <div className="ant-employed">
              <span>{location?.locationAddress}</span>
            </div>
          </>
        ),

        client: (
          <>
            <div className="ant-employed" style={{ cursor: "auto" }}>
              <strong>{location?.client}</strong>
            </div>
          </>
        ),

        region: (
          <>
            <div className="ant-employed">
              <span>{location?.region}</span>
            </div>
          </>
        ),

        costCenter: (
          <>
            <div className="ant-employed">
              <span>{location?.costCenter}</span>
            </div>
          </>
        ),

        email: (
          <>
            <div className="ant-employed">
              <span>
                {location?.email?.length > 50
                  ? location?.email?.slice(0, 50) + "..."
                  : location?.email}
              </span>
              <Link
                style={{ marginLeft: "10px", color: "#1EC8FF" }}
                to={`location/${location.id}`}
              >
                Edit
              </Link>
            </div>
          </>
        ),
        // email2: (
        //   <>
        //     <div className="ant-employed">
        //       <span>{location?.email2}</span>
        //       <Link
        //         style={{ marginLeft: "10px", color: "#1EC8FF" }}
        //         to={`location/${location.id}`}
        //       >
        //         Edit
        //       </Link>
        //     </div>
        //   </>
        // ),
      };
    });

  const getLocations = async () => {
    const token = localStorage.getItem("token");
    try {
      setLoading(true);
      const response = await axios.get(
        process.env.REACT_APP_API_URL + "location/getAllLocations",
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      console.log(response);
      setLocations(response.data);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const handleChange = (value) => {
    console.log(`selected ${value}`);
    setSelectedClient(value);
  };

  const getClients = async () => {
    const token = localStorage.getItem("token");
    try {
      setLoadingClients(true);
      const response = await axios.get(
        process.env.REACT_APP_API_URL + "clients/getAllClients",
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      console.log(response);
      setClients(response.data);
      setLoadingClients(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    let currentDate = new Date();
    setToken(localStorage.getItem("token"));
    console.log("app token", token);
    if (
      (token && jwtDecode(token).exp * 1000 < currentDate.getTime()) ||
      token === null
    ) {
      history.push("/sign-in");
    } else {
      history.push(location.pathname);
    }
  }, [token]);

  useEffect(() => {
    getClients();
  }, []);

  useEffect(() => {
    getLocations();
  }, []);

  const exportLocations = async () => {
    const token = localStorage.getItem("token");

    try {
      const response = await axios.get(
        process.env.REACT_APP_API_URL +
          "csvExport/exportLocationsToCSV?separator=%2C",
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "text/csv",
            "Content-Type": "application/json",
          },
          responseType: "blob",
        }
      );

      const blob = new Blob([response.data], { type: "text/csv" });

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;

      link.setAttribute("download", "locations.csv");

      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <>
      {contextHolder}
      <div className="tabled">
        <Row gutter={[24, 0]}>
          <Col xs="24" xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title="Locations"
              extra={
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "wrap",
                  }}
                >
                  <Select
                    // defaultValue={societatiPaza[0].value}
                    value={selectedClient}
                    style={{
                      width: 200,
                      marginRight: "10px",
                      height: "100%",
                      marginBottom: "10px",
                      marginTop: "10px",
                    }}
                    onChange={handleChange}
                    options={clients.map((client) => {
                      return {
                        label: client?.name,
                        value: client?.name,
                      };
                    })}
                  />

                  <Input
                    style={{
                      marginRight: "10px",
                      width: "200px",
                      marginBottom: "10px",
                      marginTop: "10px",
                    }}
                    size="small"
                    prefix={
                      <SearchOutlined
                        size="small"
                        // style={{
                        //   backgroundColor: "red",
                        //   padding: "0px",
                        //   margin: "0px",
                        //   height: "10px",
                        // }}
                        className="site-form-item-icon"
                      />
                    }
                    placeholder="Search location"
                    onChange={(e) => setQuery(e.target.value)}
                    // style={{ width: 150, height: "100%" }}
                  />

                  <NavLink
                    to="/add-location"
                    style={{
                      marginBottom: "10px",
                      marginTop: "10px",
                      marginRight: "10px",
                    }}
                  >
                    <Button type="secondary" className="tag-primary">
                      <PlusOutlined />
                      Add Location
                    </Button>
                  </NavLink>
                  <Button
                    onClick={() => exportLocations()}
                    style={{ marginBottom: "10px", marginTop: "10px" }}
                    type="secondary"
                    className="tag-secondary"
                  >
                    Export Locations
                  </Button>
                  {/*TODO Search box*/}
                  {/*<Input*/}
                  {/*  style={{ marginLeft: "20px" }}*/}
                  {/*  className="header-search"*/}
                  {/*  placeholder="Type here..."*/}
                  {/*  prefix={<SearchOutlined />}*/}
                  {/*/>*/}
                  {/*TODO Radio Button*/}
                  {/*<Radio.Group style={{display: "flex", flexDirection: "row"}} onChange={onChange} defaultValue="a">*/}
                  {/*  <Radio.Button value="a">All</Radio.Button>*/}
                  {/*  <Radio.Button value="b">ONLINE</Radio.Button>*/}
                  {/*</Radio.Group>*/}
                </div>
              }
            >
              <div className="table-responsive">
                {loading ? (
                  <Spinner />
                ) : (
                  <Table
                    style={{ padding: "10px" }}
                    columns={columns}
                    dataSource={data}
                    pagination={true}
                    className="ant-border-space"
                  />
                )}
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default Locations;
